import React from "react";
import AssignmentIcon from '@mui/icons-material/Assignment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

export const getMenuItems = ({ isPrepcaConnectToshow = false } = {}) => {
    const items = [
        { label: "Question", to: "/dashboard/question", icon: <AssignmentIcon /> },
        { label: "Upload Answers", to: "/dashboard/upload-answer", icon: <CloudUploadIcon /> },
        { label: "Suggested Answers", to: "/dashboard/answer", icon: <CalendarMonthIcon /> },
        { label: "Evaluated Answer Sheets", to: "/dashboard/evaluated", icon: <PictureAsPdfIcon /> },
        isPrepcaConnectToshow && {
            label: "Prepca Connect",
            to: "/dashboard/counseling/created",
            icon: <PeopleAltIcon />
        },
        { label: "Download Center", to: "/dashboard/download-center", icon: <SimCardDownloadIcon /> },
        { label: "Planner", to: "/dashboard/planner", icon: <CalendarTodayIcon fontSize="small" /> },
        { label: "My Subscription", to: "/dashboard/orders", icon: <AssignmentTurnedInIcon /> },
        { to: "/dashboard/webinar", label: "Webinar", icon: <VideoCameraFrontIcon fontSize="small" style={{ marginLeft: 3 }} /> },
        { label: "Bonuses", to: "/dashboard/bonuses", icon: <CardGiftcardIcon /> },
        { label: "Support", to: "https://forms.gle/kvDtdxoXVfYkq1Tj7", icon: <HeadphonesIcon />, external: true },
        { label: "Profile", to: "/dashboard/account", icon: <AccountCircleIcon /> },
        { label: "Logout", to: "/logout", icon: <LogoutIcon /> }
    ];

    return items.filter(Boolean);
};
